"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommentDetailDto = exports.CommentDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const Account_dto_1 = require("./Account.dto");
const CommentAttachment_dto_1 = require("./CommentAttachment.dto");
const CommentReply_dto_1 = require("./CommentReply.dto");
const CommentVenueSuggestion_dto_1 = require("./CommentVenueSuggestion.dto");
const RefundRequest_dto_1 = require("./RefundRequest.dto");
class CommentDto {}
exports.CommentDto = CommentDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], CommentDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], CommentDto.prototype, "subject", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], CommentDto.prototype, "message", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], CommentDto.prototype, "emailAddress", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: 'string',
  nullable: true
}), __metadata("design:type", Object)], CommentDto.prototype, "userPublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], CommentDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], CommentDto.prototype, "updatedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: 'string',
  nullable: true
}), __metadata("design:type", Object)], CommentDto.prototype, "closedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], CommentDto.prototype, "replyCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: 'string',
  nullable: true
}), __metadata("design:type", Object)], CommentDto.prototype, "lastReplyAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: 'string',
  nullable: true
}), __metadata("design:type", Object)], CommentDto.prototype, "lastReplyPreview", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], CommentDto.prototype, "lastReplyIsFromAdmin", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: Account_dto_1.AccountDto
}), __metadata("design:type", Account_dto_1.AccountDto)], CommentDto.prototype, "account", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: CommentVenueSuggestion_dto_1.CommentVenueSuggestionDto,
  nullable: true
}), __metadata("design:type", Object)], CommentDto.prototype, "venueSuggestion", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: RefundRequest_dto_1.RefundRequestSummaryDto,
  nullable: true,
  description: 'Set when the topic discusses a ticket refund.'
}), __metadata("design:type", Object)], CommentDto.prototype, "refundRequest", void 0);
class CommentDetailDto extends CommentDto {}
exports.CommentDetailDto = CommentDetailDto;
__decorate([(0, swagger_1.ApiProperty)({
  type: CommentAttachment_dto_1.CommentAttachmentDto,
  isArray: true
}), __metadata("design:type", Array)], CommentDetailDto.prototype, "attachments", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: CommentReply_dto_1.CommentReplyDto,
  isArray: true
}), __metadata("design:type", Array)], CommentDetailDto.prototype, "replies", void 0);
//# sourceMappingURL=Comment.dto.js.map